import { Routes, Route } from 'react-router-dom';
import NavBar from './components/NavBar';
import Home from './pages/home';
import Login    from './pages/login';
import Register    from './pages/register';
import Profile    from './pages/profile';
import Dashboard from './pages/dashboard'
import Teams from './pages/teams'
import ClubUrlRoute from './components/teams/ClubUrlRoute';
import SearchForTeams from './pages/searchForTeams';
import JoinPage from './pages/join/[teamId]';
import PasswordReset from './pages/reset-password';
import AccountAction from './pages/account-action';
import VerifyEmail from './pages/verify-email';
import PaymentSuccessPage from './pages/teams/[teamid]/payment-success';
import PaymentCancelledPage from './pages/teams/[teamid]/payment-cancelled';
import ClubBillingPage from './pages/teams/[teamid]/club-billing';
import MembershipReconciliationPage from './pages/teams/[teamid]/membership-reconciliation';
import ReportingPage from './pages/teams/[teamid]/reporting';
import DemographicsPage from './pages/teams/[teamid]/demographics';
import MooringPaymentPage from './pages/moorings/payment';
import SubscriptionCheckout from './pages/subscriptionCheckout';
import Pricing from './pages/pricing';
import Features from './pages/features';
import Demo from './pages/demo';
import Philosophy from './pages/philosophy';
import TeamCalendar from './pages/teams/[teamid]/calendar';
import UserCalendarPage from './pages/calendar/userCalendar';
import FamilyCalendarPage from './pages/calendar/family/[familyId]';
import MessagePage from './components/messages/MessagesPage';
import PrivacyPolicy from './pages/privacyPolicy';
import TermsOfService from './pages/termsOfService';
import Help from './pages/help'
import AdminPage from './pages/admin';
import MarketingLandingPage from './pages/marketingLanding';
import PublicEventsPage from './pages/publicEvents/PublicEventsPage';
import TicketWallet from './pages/eventTickets/TicketWallet';
import EventCheckIn from './pages/eventTickets/EventCheckIn';
import ConfirmChildMentoring from './pages/mentoring/ConfirmChildMentoring';
import MentoringPairingView from './pages/mentoring/MentoringPairingView';
import RideDeclarationProof from './pages/rideDeclarations/RideDeclarationProof';
import RideDeclarationVerify from './pages/rideDeclarations/RideDeclarationVerify';
import MembershipClaimPage from './pages/membershipClaim';
import ScrollToTop from './components/ScrollToTop';
import EmergencyContactReminder from './components/checks/emergencyContactReminder';
import ProfileDetailsReminder from './components/checks/profileDetailsReminder';
import LegalUpdateAcknowledgement from './components/checks/LegalUpdateAcknowledgement';
import { isStandaloneDisplay, PwaInstallPromptProvider } from './components/pwa/PwaInstallContext';
import PwaInstallBanner from './components/pwa/PwaInstallBanner';
import PwaUpdateToast from './components/pwa/PwaUpdateToast';
import OfflineStatusBanner from './components/pwa/OfflineStatusBanner';
import OfflineWriteGuard from './components/pwa/OfflineWriteGuard';
import AppResumeMonitor from './components/pwa/AppResumeMonitor';
import NotificationClickNavigator from './components/pwa/NotificationClickNavigator';
import AppBootScreen from './components/pwa/AppBootScreen';
import { useAuth } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import './styles/layout.css';

function protectedElement(element) {
  return <ProtectedRoute>{element}</ProtectedRoute>;
}

function AppShell() {
  return (
    <>
      <ScrollToTop />
      <EmergencyContactReminder />
      <ProfileDetailsReminder />
      <LegalUpdateAcknowledgement />
      <PwaInstallBanner />
      <PwaUpdateToast />
      <AppResumeMonitor />
      <NotificationClickNavigator />
      <OfflineStatusBanner />
      <OfflineWriteGuard />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/features" element={<Features />} />
        <Route path="/features/:featureSlug" element={<MarketingLandingPage />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/philosophy" element={<Philosophy />} />
        <Route path="/rowing-club-software" element={<MarketingLandingPage />} />
        <Route path="/rowing-club-management-software" element={<MarketingLandingPage />} />
        <Route path="/boat-club-management-software" element={<MarketingLandingPage />} />
        <Route path="/sailing-club-software" element={<MarketingLandingPage />} />
        <Route path="/sailing-club-membership-software" element={<MarketingLandingPage />} />
        <Route path="/canoe-club-software" element={<MarketingLandingPage />} />
        <Route path="/sports-club-software" element={<MarketingLandingPage />} />
        <Route path="/community-organisation-management-software" element={<MarketingLandingPage />} />
        <Route path="/club-membership-software" element={<MarketingLandingPage />} />
        <Route path="/club-payments" element={<MarketingLandingPage />} />
        <Route path="/membership-renewal-software" element={<MarketingLandingPage />} />
        <Route path="/club-event-management" element={<MarketingLandingPage />} />
        <Route path="/events/:clubSlug/:eventSlug" element={<PublicEventsPage />} />
        <Route path="/events/:clubSlug" element={<PublicEventsPage />} />
        <Route path="/login"    element={<Login />} />
        <Route path="/register"    element={<Register />} />
        <Route path="/profile"    element={protectedElement(<Profile />)} />
        <Route path="/dashboard"    element={protectedElement(<Dashboard />)} />
        <Route path="/teams"    element={protectedElement(<Teams />)} />
        <Route path="/teams/:id" element={protectedElement(<ClubUrlRoute />)} />
        <Route path="/teams/search" element={protectedElement(<SearchForTeams />)} />
        <Route path="/join/:teamId" element={<JoinPage />} />
        <Route path="/teams/:teamId/calendar" element={protectedElement(<TeamCalendar />)} />
        <Route path="/tickets/:teamId/course/:courseId" element={protectedElement(<TicketWallet sourceType="course" />)} />
        <Route path="/tickets/:teamId/:eventId" element={protectedElement(<TicketWallet />)} />
        <Route path="/teams/:teamId/courses/:courseId/check-in" element={protectedElement(<EventCheckIn sourceType="course" />)} />
        <Route path="/teams/:teamId/events/:eventId/check-in" element={protectedElement(<EventCheckIn />)} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route path="/account-action" element={<AccountAction />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/membership-claim" element={<MembershipClaimPage />} />
        <Route path="/teams/:teamId/payment-success" element={protectedElement(<PaymentSuccessPage />)} />
        <Route path="/teams/:teamId/payment-cancelled" element={protectedElement(<PaymentCancelledPage />)} />
        <Route path="/teams/:teamId/club-billing" element={protectedElement(<ClubBillingPage />)} />
        <Route path="/teams/:teamId/membership-reconciliation" element={protectedElement(<MembershipReconciliationPage />)} />
        <Route path="/teams/:teamId/reporting" element={protectedElement(<ReportingPage />)} />
        <Route path="/teams/:teamId/demographics" element={protectedElement(<DemographicsPage />)} />
        <Route path="/moorings/pay/:linkId" element={protectedElement(<MooringPaymentPage />)} />
        <Route path="/subscriptionCheckout" element={protectedElement(<SubscriptionCheckout />)} />
        <Route path="/calendar/user" element={protectedElement(<UserCalendarPage />)} />
        <Route path="/calendar/family/:familyId" element={protectedElement(<FamilyCalendarPage />)} />
        <Route path="/messages/:threadId?" element={protectedElement(<MessagePage />)} />
        <Route path="/mentoring/confirm" element={protectedElement(<ConfirmChildMentoring />)} />
        <Route path="/mentoring/pairing" element={protectedElement(<MentoringPairingView />)} />
        <Route path="/teams/:teamId/ride-declaration" element={protectedElement(<RideDeclarationProof />)} />
        <Route path="/teams/:teamId/ride-declaration/verify" element={protectedElement(<RideDeclarationVerify />)} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/help" element={<Help />} />
        <Route path="/admin" element={protectedElement(<AdminPage />)} />
        <Route path="/admin/content-review" element={protectedElement(<AdminPage initialSection="content-review" />)} />
      </Routes>
    </>
  );
}

function App() {
  const { authLoading } = useAuth();

  return (
    <PwaInstallPromptProvider>
      {authLoading && isStandaloneDisplay() ? <AppBootScreen /> : <AppShell />}
    </PwaInstallPromptProvider>
  );
}

export default App;
